module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("dbM8r"))).then(() => parcelRequire('3cbk1'));